import React, { useEffect, useState } from "react";
import DashboardViewNotif from "./DashboardViewNotif";
import axios from "axios";
import { getAuthCredentials } from "../../../utils/auth";

const DashboardNotif = ({ user }) => {
  const [unviewedNotifs, setUnviewedNotifs] = useState([]);
  const [viewOpen, setViewOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const currentNotif = unviewedNotifs[currentPage];

  useEffect(() => {
    const fetchUnviewedNotifications = async () => {
      try {
        const { token } = await getAuthCredentials();
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/v1/api/notification/unviewed`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { userId: user.userId },
          }
        );

        const notifs = response.data.notifications || [];
        if (notifs.length > 0) {
          setUnviewedNotifs(notifs);
          setCurrentPage(0);
          setViewOpen(true);
        }
      } catch (err) {
        console.error("Failed to fetch unviewed notifications:", err);
      }
    };

    if (user?.userId) {
      fetchUnviewedNotifications();
    }
  }, [user?.userId]);

  const handleCloseNotif = async () => {
    try {
      const { token } = await getAuthCredentials();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/notification/view`,
        {
          userId: user.userId,
          notifIds: unviewedNotifs.map((n) => n._id),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (err) {
      console.error("Failed to mark notifications as viewed:", err);
    }

    setViewOpen(false);
    setUnviewedNotifs([]);
    setCurrentPage(0);
  };

  const handleSkip = () => {
    setViewOpen(false);
    setUnviewedNotifs([]);
    setCurrentPage(0);
  };

  return (
    <DashboardViewNotif
      open={viewOpen}
      notif={currentNotif}
      onNext={() => setCurrentPage((prev) => prev + 1)}
      onSelectPage={(index) => setCurrentPage(index)}
      onCloseAll={handleCloseNotif}
      onSkip={handleSkip}
      pageIndex={currentPage}
      total={unviewedNotifs.length}
      isLast={currentPage + 1 === unviewedNotifs.length}
    />
  );
};

export default DashboardNotif;
